export const GroupsCollection = 'groups';
export const UsersCollection = 'users';
export const GuidosCollection = 'guidos';
export const CreatedGuidosCollection = 'createdGuidos';
export const AssignedGuidosCollection = 'assignedGuidos';
//================================ Number Constants ===================================
export const DEFAULT_ITEMS_COUNT = 10;
export const EMPTY_STRING = '';
